<template>
  <v-menu v-if="SETTINGS.languages.length > 1" max-height="400px">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        class="header-language-selector bcl-app-header-options px-2 px-lg-4"
        title="Language"
      >
        <span class="text-uppercase">{{ language }}</span>
        <v-icon class="mr-n1">mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-list>
      <template v-for="lang in SETTINGS.languages" :key="lang">
        <v-list-item
          v-if="language !== lang"
          :value="lang"
          @click="setActiveLanguage(lang)"
        >
          <v-list-item-title>
            <span class="text-uppercase">{{ lang }}</span>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useAppStore } from "@/stores";
import { SETTINGS } from "@/utils/constants";

const { language } = storeToRefs(useAppStore());
const { setActiveLanguage } = useAppStore();
</script>
